exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".person{display:flex;flex-direction:row}.person__main{margin-bottom:30px;margin-right:20px;position:relative;width:calc(100% - 300px)}.person__aside{max-width:280px}.person__header{margin-bottom:25px;text-align:center}.person__header__avatar{display:inline-block;margin-bottom:35px;position:relative}.person__header__title{font-size:1.143em;margin:15px 0}.person__header__image-buttons{align-items:center;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-end;margin-bottom:-40px;position:relative;top:-60px}@media (max-width: 767px){.person__header__image-buttons{margin-bottom:-10px;top:-30px}}.person__biography{font-size:1em;line-height:21px;margin-bottom:20px;white-space:pre-line}.person__collections div:last-child{border-bottom:none}@media (max-width: 639px){.person{flex-direction:column}.person__main{margin-right:0}.person__main,.person__aside{max-width:100%;position:unset;width:100%}}\n", ""]);

// exports
exports.locals = {
	"person": "person",
	"person__main": "person__main",
	"person__aside": "person__aside",
	"person__header": "person__header",
	"person__header__avatar": "person__header__avatar",
	"person__header__title": "person__header__title",
	"person__header__image-buttons": "person__header__image-buttons",
	"person__biography": "person__biography",
	"person__collections": "person__collections"
};